import { render, staticRenderFns } from "./CreateTaskPopup.vue?vue&type=template&id=0d29b860"
import script from "./CreateTaskPopup.vue?vue&type=script&lang=js"
export * from "./CreateTaskPopup.vue?vue&type=script&lang=js"
import style0 from "./CreateTaskPopup.vue?vue&type=style&index=0&id=0d29b860&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports